import { render, staticRenderFns } from "./Orientations.vue?vue&type=template&id=404c443a"
import script from "./Orientations.vue?vue&type=script&lang=js"
export * from "./Orientations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports